import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, ComponentFactoryResolver, Input, TemplateRef } from '@angular/core';
import { BaseEntity } from '../../base-models/base-entity';
import { BaseDefaultListComponent } from './base-default-list.component';
import { BaseDataService } from '../../base-services/base-data.service';
import { TranslateCompiler, TranslateService } from '@ngx-translate/core';
// import { NotificationsService } from 'angular2-notifications';
import { UserService } from '../../base-services/user.service';
import { ModalService } from '../../base-services/modal.service';
import { PageContainerService } from '../../base-classes/containers/services/page-container.service';
import { NotificationService } from '../../base-services/notification-service';
// import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'yt-fw-default-list-page',
    templateUrl: './default-list-tabs.component.html'
})
export class DefaultListPageComponent<T extends BaseEntity> extends BaseDefaultListComponent<T> implements OnInit {
    // constructor(
    //     protected activatedRoute: ActivatedRoute,
    //     protected baseDataService: BaseDataService,
    //     protected pageContainerService: PageContainerService<T>,
    //     protected userService: UserService,
    //     protected notificationService: NotificationsService,
    //     protected translateService: TranslateService,
    //     protected modalService: ModalService,
    //     protected componentFactoryResolver: ComponentFactoryResolver
    // ){
    //     super(activatedRoute, baseDataService, pageContainerService, userService, notificationService, translateService, modalService, componentFactoryResolver);
    // }

    constructor(
        protected activatedRoute: ActivatedRoute,
        protected baseDataService: BaseDataService,
        protected pageContainerService: PageContainerService<T>,
        protected userService: UserService,
        protected toastrService: NotificationService,
        protected translateService: TranslateService,
        protected modalService: ModalService,
        protected componentFactoryResolver: ComponentFactoryResolver
    ){
        super(activatedRoute, baseDataService, pageContainerService, userService, toastrService, translateService, modalService, componentFactoryResolver);
  }

    @Input() extraButtonsTemplate: TemplateRef<any>;
    ngOnInit(){
        super.ngOnInit();
    }
}
